<template>
    <transition name="toast">
        <div v-if="visible" class="toast" :class="type" @click="hideToast">
            <span>{{ message }}</span>&nbsp;<a v-if="contactanos && type !== 'success'"
                href="https://docs.google.com/forms/d/18aMGrwHl0ZLLWMgXbXfmLqWfwyIU42wYc15WlVfU9KY/edit">Contactanos</a>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            message: "",
            type: "error", // Default type is 'error', can also be 'success', 'warning', etc.
            contactanos: true,
        };
    },
    methods: {
        showToast(message, type = "error", duration = 6000) {
            this.message = message;
            this.type = type;
            this.visible = true;
            setTimeout(() => {
                this.visible = false;
            }, duration); // Toast will hide automatically after duration
        },
        hideToast() {
            this.visible = false; // Manual close on click
        },
    },
};
</script>

<style scoped>
/* Base toast styles */
.toast {
    position: fixed;
    bottom: 20vh;
    right: 24px;
    padding: 24px 48px;
    background-color: #f56565;
    /* Default red for error */
    color: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    opacity: 0.9;
    transition: opacity 0.4s ease-in-out;
    z-index: 20;
    font-size: 14pt;
    max-width: 60vw;
}

.toast.success {
    background-color: #48bb78;
    /* Green for success */
}

.toast.warning {
    background-color: #ecc94b;
    color: #000;
    /* Yellow for warnings */
}

.toast.error {
    background-color: #f56565;
    /* Red for errors */
}

/* Animation for fading in and sliding up */
@keyframes toastFadeIn {
    0% {
        opacity: 0;
        transform: translateY(20vh);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Animation for fading out and sliding down */
@keyframes toastFadeOut {
    0% {
        opacity: 1;
        transform: translateY(0);
    }

    100% {
        opacity: 0;
        transform: translateY(20vh);
    }
}

/* Define the enter and leave animations using Vue transitions */
.toast-enter-active {
    animation: toastFadeIn 0.5s ease-out;
}

.toast-leave-active {
    animation: toastFadeOut 0.5s ease-in;
}

/* MObile max-width */
@media (max-width: 768px) {
    .toast {
        right: 0;
        left: 0;
        margin: 0;
        border-radius: 0;
        max-width: 95vw;
    }
}
</style>
